<template>
  <div class="container">
    <div class="box">
      <div class="columns is-multiline" v-if="testimonial">
        <div class="column is-12">
          <div class="field">
            <label class="label">Fullname</label>
            <div class="control">
              <input type="text" class="input" placeholder="Title" v-model="testimonial.fullname">
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Testimonial</label>
            <div class="control">
              <textarea class="input" cols="30" rows="10" v-model="testimonial.text"></textarea>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <figure class="image is-128x128" v-if="testimonial.profilePicture">
            <img :src="testimonial.profilePicture">
          </figure>
          <div class="field">
            <div class="control">
              <div class="file">
                <label class="file-label">
                  <input @change="uploadImages" class="file-input" type="file" name="resume" accept=".jpg, .jpeg, .png" />
                  <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a profile picture…
                  </span>
                </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- the form buttons -->
      <button type="submit" class="button is-success" @click="updateTestimonial('published')">Publish</button>
      <button type="submit" class="button is-info" @click="updateTestimonial('saved')">Save Draft</button>
      <router-link to="/admin/testimonials" class="button is-danger">Cancel</router-link>

      <!-- notification -->
      <transition mode="out-in" name="fade">
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>{{notification.message}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mediaRef, testimonialsRef } from '@/firebase_config'
import notifier from '@/mixins/notifier'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'

export default {
  name: 'user-testimonial-edit',
  data () {
    return {
      currentUser: firebase.auth().currentUser,
      testimonial: null,
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  mixins: [imageLoader, notifier],
  methods: {
    updateTestimonial (state) {
      this.testimonial.state = state
      testimonialsRef.child(this.$route.params.key).set(this.testimonial).then(() => {
        if (this.testimonial.state === 'saved') {
          this.showNotification('success', 'Testimonial updated successfully')
        }
        if (this.testimonial.state === 'published') {
          this.showNotification('success', 'Testimonial updated and published successfully')
        }
      })
    },
    uploadImages (e) {
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/profilePictures/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)
    },
    handleUploadProgress (snapshot) {
      let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      this.showNotification('success', 'Uploading image ' + Math.floor(progress) + '% done.')

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    },
    handleUploadError (error) {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          // User doesn't have permission to access the object
          break
        case 'storage/canceled':
          console.log('storage/canceled')
          // User canceled the upload
          break
        case 'storage/unknown':
          console.log('storage/unknown')
          // Unknown error occurred, inspect error.serverResponse
          break
        default:
          console.log(error)
      }
    },
    handleUploadComplete () {
      console.log('Upload Complete!')
    },
    addImageToMedia (snapshot) {
      this.showNotification('success', snapshot.metadata.name + ' uploaded.')

      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }

      this.testimonial.profilePicture = snapshot.downloadURL

      mediaRef.push(mediaObj)
    },
    loadCurrent () {
      testimonialsRef.child(this.$route.params.key).once('value', snapshot => {
        this.testimonial = snapshot.val()
      })
    }
  },
  watch: {
    '$route' () {
      this.loadCurrent()
    }
  },
  mounted () {
    this.loadCurrent()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/TestimonialsEdit.vue